var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowLineLeft = function SvgIconArrowLineLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75a1 1 0 0 1 1 1v16.5a1 1 0 1 1-2 0V3.75a1 1 0 0 1 1-1M14.207 4.543a1 1 0 0 1 0 1.414L9.164 11H21a1 1 0 1 1 0 2H9.164l5.043 5.043a1 1 0 0 1-1.414 1.414l-6.75-6.75a1 1 0 0 1 0-1.414l6.75-6.75a1 1 0 0 1 1.414 0"
  }))));
};
export default SvgIconArrowLineLeft;